export const INSIGHT_TEMPLATES = {
    low: [
        "Começar é a parte mais difícil. Escolha um hábito fácil hoje e foque apenas nele! 🚀",
        "Não desanime! Pequenos passos levam a grandes jornadas. Que tal tentar fazer pelo menos um check-in hoje? 🌱",
        "A consistência é chave. Tente fazer seus hábitos no mesmo horário todos os dias para criar uma rotina. ⏰",
        "Se estiver difícil, tente reduzir a meta diária. O importante é não parar! 💪",
        "Lembre-se: feito é melhor que perfeito. Um pouco de progresso é melhor que nenhum. ✨"
    ],
    medium: [
        "Você está no caminho certo! Mantenha o ritmo e veja seus resultados crescerem. 📈",
        "Bom trabalho! Tente aumentar sua sequência de dias consecutivos para fortalecer seus hábitos. 🔥",
        "Você já criou uma boa base. Agora é hora de desafiar-se um pouco mais! 🎯",
        "Observe quais hábitos você tem mais facilidade e tente aplicar a mesma estratégia nos mais difíceis. 🧠",
        "Sua constância está começando a dar frutos. Continue firme! 🍎"
    ],
    high: [
        "Incrível! Sua dedicação é inspiradora. Continue assim! 🌟",
        "Você está dominando seus hábitos! Talvez seja hora de adicionar um novo desafio? 🚀",
        "Excelente consistência! Lembre-se de celebrar suas vitórias. 🎉",
        "Seu progresso é notável. Você está construindo uma versão melhor de si mesmo a cada dia. 💎",
        "Você é a prova de que a disciplina traz resultados. Parabéns! 🏆"
    ],
    general: [
        "Lembre-se do seu 'porquê'. O que te motivou a começar? 🤔",
        "Hábitos são juros compostos do autoaperfeiçoamento. 📉📈",
        "Cada check-in é um voto para a pessoa que você quer se tornar. 🗳️",
        "A motivação é o que te faz começar. O hábito é o que te faz continuar. 🔄"
    ]
};

export const getRandomInsight = (completionRate) => {
    let category = 'general';

    if (completionRate < 30) {
        category = 'low';
    } else if (completionRate < 70) {
        category = 'medium';
    } else {
        category = 'high';
    }

    // 20% de chance de pegar um insight geral independente da categoria
    if (Math.random() < 0.2) {
        category = 'general';
    }

    const templates = INSIGHT_TEMPLATES[category];
    const randomIndex = Math.floor(Math.random() * templates.length);
    return templates[randomIndex];
};
